angular.module('zc.zenclerkS')

// TODO: can be deleted after 2017-04
  .value('litePricingLaterPressed', {})

  .config(routerConfig);

routerConfig.$inject = ['$stateProvider'];
function routerConfig($stateProvider) {

  $stateProvider

  //#############################################################################
  //#
  //# 404 etc
  //#
  //#############################################################################
    .state('404', {
      url: '/404',
      views: {
        'content@': {
          templateUrl: '/templates/core/views/404.html'
        }
      }
    }).state('500', {
      url: '/500',
      views: {
        'content@': {
          templateUrl: '/templates/core/views/500.html'
        }
      }
    })
    .state('terms_of_service', {
      url: '/tos/admin',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_tos_header+main.html',
          controller: 'TosHeaderController',
          controllerAs: 'vm',
          resolve: {
            languages() {
              return [
                {
                  id: 'en',
                  label: 'English',
                },
                {
                  id: 'ja',
                  label: '日本語',
                },
                {
                  id: 'zh',
                  label: '中文',
                },
              ];
            },
          },
        },
        'mainContent@terms_of_service': {
          templateUrl: '/templates/core/views/tos.html',
          controller: 'TosController',
          controllerAs: 'vm',
        }
      },
    })
    .state('privacy_policy', {
      url: '/privacy_policy',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_tos_header+main.html',
          controller: 'TosHeaderController',
          controllerAs: 'vm',
          resolve: {
            languages() {
              return [
                {
                  id: 'en',
                  label: 'English',
                },
                {
                  id: 'ja',
                  label: '日本語',
                },
              ];
            },
          },
        },
        'mainContent@privacy_policy': {
          templateUrl: '/templates/core/views/privacy_policy.html',
          controller: 'PrivacyPolicyCtrl',
        }
      }
    })
    .state('users', {
      abstract: true,
      url: '/users'
    }).state('users.signIn', {
      url: '/sign_in',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
        },
        'mainContent@users.signIn': {
          templateUrl: '/templates/zenclerk_s/users/sign_in/sign_in.html',
          controller: 'UsersSignInController',
          controllerAs: '$ctrl'
        }
      },
      beforeAction(ZcsOemService, afterLoginHandler, currentUser, toState) {
      // oem service should not show sign in because it uses single sign on
        if((toState.name === 'users.signIn') && ZcsOemService.isOemService()) {
          return afterLoginHandler.handle(currentUser, {forceReload: true});
        }
        return true;
      }

    }).state('users.invitation', {
      abstract: true,
      url: '/invitation'

    }).state('users.invitation.accept', {
      url: '/accept?invitation_token',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
        },
        'mainContent@users.invitation.accept': {
          templateUrl: '/templates/zenclerk_s/users/invitation/accept.html',
          controller: 'AcceptInvitationController',
          controllerAs: 'vm',
        }
      },
      resolve: {
        invitedUser($state, $stateParams, Devise) {
          return Devise.validateInvitationToken($stateParams.invitation_token)
            .then(function(user) {
              if(!user) {
                return $state.go('users.signIn');
              }
              return user;
            });
        }
      }

    }).state('users.resetPassword', {
      url: '/password/edit?reset_password_token',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
        },
        'mainContent@users.resetPassword': {
          templateUrl: '/templates/zenclerk_s/users/reset_password/reset_password.html',
          controller: 'ResetPasswordController',
          controllerAs: '$ctrl'
        }
      }

    }).state('zenclerkS', {
      url: '',
      abstract: true,
      resolve: {
        currentUser(Devise) {
          return Devise.getCurrentUser();
        },
        noFooter(Page, ZcsOemService) {
          Page.setTitle(ZcsOemService.getName());
          Page.showFooter = false;
        }
      },
      beforeAction($state, ZcsOemService, currentUser, toState) {
        if(!currentUser) {
          $state.go('users.signIn');
          return false;
        }

        if(ZcsOemService.isOemService()) { return true }
        if(toState.name === 'zenclerkS.pricing') { return true }
        if(toState.name === 'zenclerkS.setup.user') { return true }

        if(!currentUser.userinfo_confirmed_at) {
          $state.go('zenclerkS.setup.user');
          return false;
        }
        return true;
      }

    }).state('zenclerkS.home', {
      url: '/home',
      beforeAction($q, $state, Agency, ZcsProject, currentUser) {
        if(currentUser.role === 'master') {
          return true;
        }

        return $q.all([ZcsProject.all(currentUser.id), Agency.all()])
          .then(function(...args) {
          // if has agency, go to agency home
            const [projects, agencies] = Array.from(args[0]);
            if(agencies.length === 1) {
              $state.go('zenclerkS.agency.home', {agencyName: agencies[0].name});
              return false;
            }

            // if there is only one project, forward to that project's page
            if(projects.length === 1) {
              $state.go('zenclerkS.project.dashboard', { apikey: projects[0].apikey });
              return false;
            }
            return true;
          });
      },

      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
          controller($scope, ZcsOemService) {
            $scope.ZcsOemService = ZcsOemService;
          }
        },
        'headerNavigation@zenclerkS.home': {
          controller($scope) {
            $scope.i18nHeader = 'home.title';
          }
        },
        'mainContent@zenclerkS.home': {
          templateUrl: '/templates/zenclerk_s/home/home.html',
          controllerAs: '$ctrl',
          controller: 'ZcsHomeController',
          resolve: {
            projects(ZcsProject, currentUser) {
              return ZcsProject.all(currentUser.id);
            },

            agencies(Agency) {
              return Agency.all();
            }
          }
        }
      }
    }).state('zenclerkS.setup', {
      url: '/setup',
      abstract: true
    }).state('zenclerkS.setup.user', {
      url: '/users',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html'
        },
        'mainContent@zenclerkS.setup.user': {
          templateUrl: '/templates/zenclerk_s/setup/setup_user.html',
          controller: 'SetupUserController',
          controllerAs: 'vm',
          resolve: {
            resolve($state, ZcsOemService) {
              if(ZcsOemService.isOemService()) {
                return $state.go('zenclerkS.home');
              }
            }
          }
        }
      }
    }).state('zenclerkS.makerepeater',
      {url: '/makerepeater'})

    .state('zenclerkS.reload', { // should not have zenclerkS.project as its parent because resolved project may not be right
      url: '/sites/:apikey/reload',
      resolve: {
      // Resolve environment, so that it is fully get before actual redirect
        environment(Environment) {
          return Environment.get();
        },
        // cannot use beforeAction because it should be called before resolve
        // NOTE: require environment to be resolved first
        redirect($stateParams, $state, $window, environment) {
          const url = $state.href('zenclerkS.project.dashboard', {apikey: $stateParams.apikey}, { absolute: true });
          return $window.location.replace(url);
        }
      }
    }).state('zenclerkS.project', {
      url: '/sites/:apikey',
      abstract: true,
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
          controller($scope, ZcsOemService) {
            $scope.ZcsOemService = ZcsOemService;
          }
        },
        'headerNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/site_navigation.html',
          controllerAs: '$ctrl',
          controller: 'ZcsSiteNavigationController'
        }
      },
      resolve: {
        project($state, $stateParams, ZcsProject, currentUser) {
          return ZcsProject.get(currentUser.id, $stateParams.apikey);
        }
      },


      beforeAction($state, Project, ZcsProject, ZcsOemService, currentUser, litePricingLaterPressed, toState, toParams) {
        if(toState.name.indexOf('zenclerkS.project.setup') === 0) {
          return true;
        }

        return ZcsProject.get(currentUser.id, toParams.apikey)
          .then(function(project) {
            Project.currentProject = project;

            // Master and agency can do whatever they want, and not enter the setup flow
            if(currentUser.role === 'master' || currentUser.agency_id) return true;

            if(project.is_demo) {
              return true;
            // Do terminated checks first so that client does not go to setup when terminated
            // Makerepeater / OEM projects should not be affected by terminated
            } else if(!project.is_oem && (project.terminated_at !== null) && (toState.name === 'zenclerkS.project.terminated')) {
              return true;
            } else if(!project.is_oem && (project.terminated_at !== null) && (toState.name.indexOf('zenclerkS.project.invoices') === 0)) {
              return true;
            } else if(!project.is_oem && (project.terminated_at !== null) && (toState.name === 'zenclerkS.project.incentives')) {
              return true;
            } else if(!project.is_oem && (project.terminated_at !== null) && (toState.name === 'zenclerkS.project.campaign.summary')) {
              return true;
            } else if(!project.is_oem && (project.terminated_at !== null) && (toState.name.indexOf('zenclerkS.project.campaigns') !== -1)) {
              if(!toState.name.endsWith('finished')) {
                $state.go('zenclerkS.project.campaigns.finished', { apikey: toParams.apikey });
                return false;
              }

              return true;
            } else if(!project.is_oem && (project.terminated_at !== null) && moment(project.terminated_at).isBefore(moment())) {
              $state.go('zenclerkS.project.terminated', {apikey: toParams.apikey});
              return false;
            // When still in middle of setup
            } else if(!project.companyinfo_confirmed_at) {
              $state.go('zenclerkS.project.setup.company', {apikey: toParams.apikey});
              return false;
            } else if(!project.siteinfo_confirmed_at) {
              $state.go('zenclerkS.project.setup.site', {apikey: toParams.apikey});
              return false;
            // makerepeater should never see anything about pricing
            } else if((ZcsOemService.get() === 'makerepeater') || project.is_oem) {
              return true;
            } else if(!project.pricing_confirmed_at && !project.pricing_pre_201704_confirmed_at) {
              $state.go('zenclerkS.project.setup.pricing', {apikey: toParams.apikey});
              return false;
            }
            return true;
          });
      }
    }).state('zenclerkS.project.setup', {
      url: '/setup',
      abstract: true,
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
          controller($scope, ZcsOemService) {
            $scope.ZcsOemService = ZcsOemService;
          }
        },
        'headerNavigation@zenclerkS.project.setup': {
          controller($scope) {
            $scope.ZcsOemService = 'setup';
            $scope.i18nHeader = 'sites.setup.title';
          }
        },
        'mainContent@zenclerkS.project.setup': {
          templateUrl: '/templates/zenclerk_s/sites/setup/setup.html',
          controller: 'ZcsSetupController',
          controllerAs: 'vm'
        }
      },
      data: {
        category: 'setup'
      }
    }).state('zenclerkS.project.setup.company', {
      url: '/company',
      views: {
        'siteSetupView@zenclerkS.project.setup': {
          templateUrl: '/templates/zenclerk_s/sites/setup/setup_company.html',
          controller: 'ZcsSetupCompanyController',
          controllerAs: 'vm'
        }
      }
    }).state('zenclerkS.project.setup.site', {
      url: '/site',
      views: {
        'siteSetupView@zenclerkS.project.setup': {
          templateUrl: '/templates/zenclerk_s/sites/setup/setup_site.html',
          controller: 'ZcsSetupSiteController',
          controllerAs: 'vm'
        }
      }
    }).state('zenclerkS.project.setup.pricing', {
      url: '/pricing',
      views: {
        'siteSetupView@zenclerkS.project.setup': {
          templateUrl: '/templates/zenclerk_s/sites/setup/setup_pricing.html',
          controller: 'ZcsSetupPricingController',
          controllerAs: 'vm'
        }
      }
    }).state('zenclerkS.project.setup.trackingTag', {
      url: '/tracking_tag',
      views: {
        'siteSetupView@zenclerkS.project.setup': {
          templateUrl: '/templates/zenclerk_s/sites/setup/setup_tracking_tag.html',
          controller: 'ZcsSetupTrackingTagController',
          controllerAs: 'vm'
        }
      }
    }).state('zenclerkS.project.setup.conversionTag', {
      url: '/conversion_tag',
      views: {
        'siteSetupView@zenclerkS.project.setup': {
          templateUrl: '/templates/zenclerk_s/sites/setup/setup_conversion_tag.html',
          controller: 'ZcsSetupConversionTagController',
          controllerAs: 'vm'
        }
      }
    }).state('zenclerkS.project.setup.complete', {
      url: '/complete',
      views: {
        'siteSetupView@zenclerkS.project.setup': {
          templateUrl: '/templates/zenclerk_s/sites/setup/setup_complete.html'
        }
      }
    }).state('zenclerkS.project.terminated', {
      url: '/terminated',
      data: {
        group: 'terminated',
        category: 'terminated'
      },
      views: {
        'subNavigation@zenclerkS.project': {
          template: ''
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-terminated project="$resolve.project"></zcs-terminated>'
        }
      }
    }).state('zenclerkS.project.dashboard', {
      url: '',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/dashboard/dashboard.html',
          controller($scope, $stateParams, project) {
            $scope.apikey = $stateParams.apikey;
            $scope.project = project;
            $scope.currentMonth = moment().format('YYYY-MM');
            // TODO: we don't have data until second day and after 4:40am with current
            // aggregation, so figure out a better way
            $scope.cumulativeConversionShowMonth = moment().subtract(1, 'days').subtract(5, 'hours').format('YYYY-MM');
          }
        }
      },
      resolve: {
        redirectIfTagUnset($state, project) {
          if(!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
            $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
            return;
          }
        }
      },
      data: {
        group: 'activity',
        category: 'dashboard'
      }
    }).state('zenclerkS.project.dashboardNew', {
      url: '/dashboard?force_mode', // TODO: make this '' after release
      params: {
        force_mode: {
          value: undefined
        }
      },
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/dashboard/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-dashboard-main project="$resolve.project"></zcs-dashboard-main>',
        }
      },
      resolve: {
        redirectIfTagUnset($state, project) {
          if(!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
            $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
            return;
          }
        }
      },
      data: {
        group: 'dashboardNew',
        category: 'dashboardNew'
      }
    }).state('zenclerkS.project.analytics', {
      url: '/analytics',
      params: {
        force_mode: {
          value: undefined
        }
      },
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-analytics project="$resolve.project"></zcs-analytics>',
        }
      },
      data: {
        group: 'activity',
        category: 'analytics'
      }
    // TODO: deprecate after new dashboard is released
    // This mode has just different top menu
    }).state('zenclerkS.project.dashboardNewAnalytics', {
      url: '/analytics',
      params: {
        force_mode: {
          value: undefined
        }
      },
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/dashboard/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-analytics project="$resolve.project"></zcs-analytics>',
        }
      },
      data: {
        group: 'dashboardNew',
        category: 'analytics'
      }
    }).state('zenclerkS.project.activity', {
      url: '/realtime',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/activity/realtime/realtime.html',
          controller($scope, $stateParams, project) {
            $scope.apikey = $stateParams.apikey;
            $scope.project = project;
          }
        }
      },
      resolve: {
        redirectIfTagUnset($state, project) {
          if(!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
            $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
            return;
          }
        }
      },
      data: {
        group: 'activity',
        category: 'activity'
      }
    }).state('zenclerkS.project.reports', {
      url: '/reports',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          template: '',
          controllerAs: 'vm',
          controller($state, $stateParams, project) {
            if($state.current.name === 'zenclerkS.project.reports') {
            // subtract 1 day and 5 hours because until 2nd day morning 4:40, when
            // the aggregation runs, we have no data
            // TODO: this still leaves unknown window when there is no data between
            // 4:40am ~ 5am
              let goToMonth;
              if(project.is_terminated) {
                goToMonth = moment(project.terminated_at).format('YYYY-MM');
              } else {
              // body...
                goToMonth = moment().subtract(1, 'days').subtract(5, 'hours').format('YYYY-MM');
              }
              return $state.go('zenclerkS.project.report.show', { apikey: $stateParams.apikey, month: goToMonth });
            }
          }
        }
      },
      data: {
        group: 'activity',
        category: 'reports'
      }
    }).state('zenclerkS.project.report', {
      url: '/reports/:month',
      abstract: true
    }).state('zenclerkS.project.report.show', {
      url: '',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/reports/show/report_show.html',
          controllerAs: 'vm',
          controller: 'ZcsReportShowController',
          resolve: {
            isDeemed(project) {
              return project.invoice_calculation_type === 'deemed';
            },
            invoices($stateParams, Campaign, Incentive, ZcsInvoice, isDeemed, project) {
              if(project.is_demo) {
                return ZcsInvoice.generateDemoData();
              }
              return Incentive.all(project.id)
                .then(function(incentives) {
                  return ZcsInvoice.find($stateParams.apikey, $stateParams.month);
                });
            }
          }
        }
      },
      data: {
        group: 'activity',
        category: 'reports'
      }
    }).state('zenclerkS.project.stats', {
      url: '/stats',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/stats/list.html',
          controllerAs: 'vm',
          controller($state, $stateParams) {
            if($state.current.name === 'zenclerkS.project.stats') {
              return $state.go('zenclerkS.project.stats.show', { apikey: $stateParams.apikey, month: moment().format('YYYY-MM') });
            }
          }
        }
      },
      data: {
        group: 'activity',
        category: 'stats'
      }
    }).state('zenclerkS.project.stats.show', {
      url: '/:month',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/stats/site_stats_show.html',
          controllerAs: 'vm',
          controller: 'ZcsSiteStatsShowController'
        }
      },
      resolve: {
        stats($stateParams, MongoZcsDailyDiffStats, project) {
          return MongoZcsDailyDiffStats.find(
            { apikey: project.apikey, month: $stateParams.month },
            { sort: { summarize_at: -1 }, limit: 1 }
          ).then(res => res[0]);
        }
      },
      data: {
        group: 'activity',
        category: 'stats'
      }
    }).state('zenclerkS.project.campaigns', {
      url: '/campaigns',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html',
          controllerAs: '$ctrl',
          controller: 'ZcsCampaignNavigationController'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/campaigns/list/list.html',
          controller: 'ZcsCampaignsListController as vm'
        }
      },
      resolve: {
        redirectIfTagUnset($state, project) {
          if(!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
            $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
            return true;
          }
        },
        // require redirectIfTagUnset so that we don't redirect twice
        redirectIfNoPageTypes($state, project, campaigns, redirectIfTagUnset) {
          if(redirectIfTagUnset) { return false }
          // If site has already had a campaign, do not redirect.
          if(campaigns.length > 0) { return false }
          // This might be caused if we accidentally remove page type...

          // conversion is also required, but it is set automatically by conversion tag
          if(!project.has_necessary_zcs_page_types) {
          // Don't show maintenance page if project is_test!
            if(!project.is_test && !project.is_demo) {
              $state.go('zenclerkS.project.maintenance', { apikey: project.apikey });
            }
            return;
          }
        },

        campaigns(project, Campaign) {
          return Campaign.all({ projectId: project.id });
        }
      },

      beforeAction($state, toState, toParams) {
        if(toState.name === 'zenclerkS.project.campaigns') {
          $state.go('zenclerkS.project.campaigns.active', toParams);
        }
        return true;
      },

      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaigns.active', {
      url: '/active',
      views: {
        'campaignsList@zenclerkS.project.campaigns': {
          template: '<zcs-campaigns-list project="$resolve.project" filters="$resolve.activeFilters"></zcs-campaigns-list>'
        }
      },
      resolve: {
        activeFilters(Campaign) {
          return Campaign.activeFilters();
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaigns.draft', {
      url: '/draft',
      views: {
        'campaignsList@zenclerkS.project.campaigns': {
          template: '<zcs-campaigns-list project="$resolve.project" filters="$resolve.incompleteFilters"></zcs-campaigns-list>'
        }
      },
      resolve: {
        incompleteFilters(Campaign) {
          return Campaign.incompleteFilters();
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaigns.finished', {
      url: '/finished',
      views: {
        'campaignsList@zenclerkS.project.campaigns': {
          template: '<zcs-campaigns-list project="$resolve.project" filters="$resolve.pastFilters"></zcs-campaigns-list>'
        }
      },
      resolve: {
        pastFilters(Campaign) {
          return Campaign.pastCampaignFilters();
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaign', {
      url: '/campaigns/:campaignId',
      abstract: true,
      resolve: {
        campaign($state, $stateParams, Campaign, project) {
          if(!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
            $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
            return;
          }
          if($stateParams.campaignId === 'new') {
            return {
              id: 'new',
              name: '',
              campaign_type: 'Coupon',
              status: 'incomplete',
              incentives: [],
              start_at_obj: {},
              end_at_obj: {},
              custom_css: '',
              element: {},
              incentive_draft: {
                name: '',
                discount_type: undefined,
                discount_price: undefined,
                discount_percent: undefined,
                is_free_shipping: false,
                has_price_limit: false,
                is_price_limit_tax_included: undefined,
                minimum_price: undefined
              }
            };
          }
          return Campaign.get({projectId: project.id, campaignId: $stateParams.campaignId});
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaign.summary', {
      url: '/summary',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html',
          controllerAs: '$ctrl',
          controller: 'ZcsCampaignNavigationController'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-campaign-summary campaign="$resolve.campaign" project="$resolve.project"></zcs-campaign-summary>',
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaign.edit', {
      url: '/edit',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
        },
        'mainContent@zenclerkS.project.campaign.edit': {
          template: '<zcs-campaign-edit project="$resolve.project" campaign="$resolve.campaign"><zcs-campaign-edit>'
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns',
        hideMainHelp: 'true'
      }
    }).state('zenclerkS.project.campaign.edit.segment', {
      url: '/segment',
      views: {
        'campaignEditView@zenclerkS.project.campaign.edit': {
          template: '<zcs-campaign-edit-step-segment><zcs-campaign-edit-step-segment>'
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaign.edit.coupon', {
      url: '/coupon?segment',
      views: {
        'campaignEditView@zenclerkS.project.campaign.edit': {
          template: '<zcs-campaign-edit-step-coupon><zcs-campaign-edit-step-coupon>'
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaign.edit.design', {
      url: '/design',
      views: {
        'campaignEditView@zenclerkS.project.campaign.edit': {
          template: '<zcs-campaign-edit-step-design><zcs-campaign-edit-step-design>'
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaign.edit.delivery', {
      url: '/ai',
      views: {
        'campaignEditView@zenclerkS.project.campaign.edit': {
          template: '<zcs-campaign-edit-step-delivery lite-sampling-ranges="$resolve.liteSamplingRanges"><zcs-campaign-edit-step-delivery>'
        }
      },
      resolve: {
        liteSamplingRanges(Meta) {
          return Meta.getLiteSamplingRanges();
        },
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaign.edit.schedule', {
      url: '/schedule',
      views: {
        'campaignEditView@zenclerkS.project.campaign.edit': {
          template: '<zcs-campaign-edit-step-schedule><zcs-campaign-edit-step-schedule>'
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.campaign.edit.confirm', {
      url: '/confirm',
      views: {
        'campaignEditView@zenclerkS.project.campaign.edit': {
          template: '<zcs-campaign-edit-step-confirm><zcs-campaign-edit-step-confirm>'
        }
      },
      data: {
        group: 'campaigns',
        category: 'campaigns'
      }
    }).state('zenclerkS.project.interestWidget', {
      abstract: true,
      url: '/iw',
      data: {
        group: 'interestWidget',
        category: 'interestWidget'
      }
    }).state('zenclerkS.project.interestWidget.results', {
      url: '/results',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/interest_widget/interest_widget_navigation.html',
          controllerAs: '$ctrl',
          controller: 'ZcsInterestWidgetNavigationController'
        },
        'mainContent@zenclerkS.project': {
          controller($state, $stateParams) {
            if($state.current.name === 'zenclerkS.project.interestWidget.results') {
              const currentMonth = moment().subtract(1, 'days').format('YYYY-MM');
              return $state.go('zenclerkS.project.interestWidget.results.show', { apikey: $stateParams.apikey, month: currentMonth });
            }
          }
        }
      }
    }).state('zenclerkS.project.interestWidget.results.show', {
      url: '/:month',
      views: {
        'mainContent@zenclerkS.project': {
          template: '<zcs-interest-widget-results project="$resolve.project" month="$resolve.month"></zcs-interest-widget-results>',
          resolve: {
            month($stateParams) {
              return $stateParams.month;
            }
          }
        }
      },
      data: {
        group: 'interestWidget',
        category: 'interestWidgetResults'
      }
    }).state('zenclerkS.project.interestWidget.settings', {
      url: '/settings',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/interest_widget/interest_widget_navigation.html',
          controllerAs: '$ctrl',
          controller: 'ZcsInterestWidgetNavigationController'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-interest-widget-settings project="project"></zcs-interest-widget-settings>',
          controller($scope, project) {
            $scope.project = project;
          }
        }
      },
      data: {
        group: 'interestWidget',
        category: 'interestWidgetSettings'
      }
    }).state('zenclerkS.project.incentives', {
      url: '/incentives',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html',
          controllerAs: '$ctrl',
          controller: 'ZcsCampaignNavigationController'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-coupon-history project="$resolve.project" shows-detail="true"></zcs-coupon-history>'
        }
      },
      data: {
        group: 'campaigns',
        category: 'incentives'
      }
    }).state('zenclerkS.project.integratedIncentives', {
      url: '/integratedIncentives',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html',
          controllerAs: '$ctrl',
          controller: 'ZcsCampaignNavigationController'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-integrated-coupon-list project="$resolve.project"></zcs-integrated-coupon-list>'
        }
      },
      data: {
        group: 'campaigns',
        category: 'integratedIncentives'
      }
    }).state('zenclerkS.project.invoices', {
      abstract: true,
      url: '/invoices',
      data: {
        group: 'invoices',
        category: 'invoices'
      }
    }).state('zenclerkS.project.invoices.list', {
      url: '',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/invoices/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/invoices/list/invoices_list.html',
          controller: 'ZcsInvoicesController as vm'
        }
      },
      resolve: {
        invoices(ZcsInvoice, project) {
          return ZcsInvoice.all(project.apikey);
        }
      },
      data: {
        group: 'invoices',
        category: 'invoices'
      }
    }).state('zenclerkS.project.invoices.show', {
      url: '/:term',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/invoices/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/invoices/show/invoice.html',
          controllerAs: 'vm',
          controller: 'ZcsInvoiceShowController'
        }
      },
      resolve: {
        month($stateParams) {
          return moment($stateParams.term, 'YYYY-MM');
        },

        invoice($state, $stateParams, ZcsInvoice, project) {
          if(!/^\d{4}-\d{2}$/.test($stateParams.term)) {
            $state.go('zenclerkS.project.invoices', { apikey: project.apikey });
          }
          return ZcsInvoice.find($stateParams.apikey, $stateParams.term);
        }
      },

      data: {
        group: 'invoices',
        category: 'invoices'
      }
    }).state('zenclerkS.project.invoices.edit', {
      url: '/:term/edit',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/invoices/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/invoices/edit/index.html',
          controller: 'ZcsInvoiceEditController as vm'
        }
      },
      resolve: {
        adjustments($stateParams, InvoiceAdjustment, project) {
          return InvoiceAdjustment.show(project, $stateParams.term);
        },

        month($stateParams) {
          return moment($stateParams.term, 'YYYY-MM');
        },

        invoice($state, $stateParams, ZcsInvoice, project) {
          if(!/^\d{4}-\d{2}$/.test($stateParams.term)) {
            $state.go('zenclerkS.project.invoices', {apikey: project.apikey});
          }
          return ZcsInvoice.find($stateParams.apikey, $stateParams.term);
        }
      },

      data: {
        group: 'invoices',
        category: 'invoicesEdit'
      }
    }).state('zenclerkS.project.settings', {
      url: '/settings',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-project-settings project="$resolve.project"></zcs-project-settings>'
        }
      },
      data: {
        group: 'settings',
        category: 'settings'
      }
    }).state('zenclerkS.project.billings', {
      url: '/billings',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-project-billings project="$resolve.project"></zcs-project-billings>'
        }
      },
      data: {
        group: 'billings',
        category: 'billings'
      }
    }).state('zenclerkS.project.users', {
      url: '/users',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/users/list.html',
          controllerAs: 'vm',
          controller: 'ZcsProjectUserController'
        }
      },
      resolve: {
        users($stateParams, ProjectUser) {
          return ProjectUser.all($stateParams.apikey);
        },
        currentUser(Devise) {
          return Devise.getCurrentUser();
        }
      },
      data: {
        group: 'settings',
        category: 'users'
      }
    }).state('zenclerkS.project.tags', {
      url: '/tags',
      abstract: true,
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/tags/site_tags.html',
          controllerAs: 'vm',
          controller: 'ZcsSiteTagsController'
        }
      }
    }).state('zenclerkS.project.tags.tracking', {
      url: '/tracking',
      views: {
        'tagView@zenclerkS.project.tags': {
          template: '<zcs-tracking-tag-checker project="$resolve.project" show-return="false"></zcs-tracking-tag-checker>'
        }
      },
      data: {
        group: 'settings',
        category: 'siteTags'
      }
    }).state('zenclerkS.project.tags.conversion', {
      url: '/conversion',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
        },
        'tagView@zenclerkS.project.tags': {
          template: '<zcs-conversion-tag-checker project="$resolve.project" show-return="false"></zcs-conversion-tag-checker>'
        }
      },
      data: {
        group: 'settings',
        category: 'siteTags'
      }
    }).state('zenclerkS.project.excludePages', {
      url: '/exclude',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-exclude-page-editor project="$resolve.project"></zcs-exclude-page-editor>'
        }
      },
      data: {
        group: 'settings',
        category: 'siteExclude'
      }
    }).state('zenclerkS.project.excludeIps', {
      url: '/exclude_ips',
      views: {
        'subNavigation@zenclerkS.project': {
          templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
        },
        'mainContent@zenclerkS.project': {
          template: '<zcs-exclude-ip-editor project="$resolve.project"></zcs-exclude-ip-editor>'
        }
      },
      data: {
        group: 'settings',
        category: 'siteExcludeIps'
      }
    }).state('zenclerkS.pricing', {
      url: '/pricing',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
          controller($scope, ZcsOemService) {
            $scope.ZcsOemService = ZcsOemService;
          }
        },
        'headerNavigation@zenclerkS.pricing': {
          controller($scope) {
            $scope.i18nHeader = 'common.pricing.title';
          }
        },
        'mainContent@zenclerkS.pricing': {
          templateUrl() {
            return '/templates/zenclerk_s/common/pricing/pricing.html';
          },
          controller($scope, $translate, Devise) {
            $scope.currentLang = $translate.use();
            $scope.signOut = Devise.signOut;
          }
        }
      }
    }).state('zenclerkS.productChanges', {
      url: '/product_changes',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
          controller($scope, ZcsOemService) {
            $scope.ZcsOemService = ZcsOemService;
          }
        },
        'headerNavigation@zenclerkS.productChanges': {
          controller($scope) {
            $scope.i18nHeader = 'common.productChanges.title';
          }
        },
        'mainContent@zenclerkS.productChanges': {
          templateUrl: '/templates/zenclerk_s/common/product_changes/product_changes_page.html'
        }
      }
    }).state('zenclerkS.maintenance', {
      url: '/maintenance',
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
        },
        'mainContent@zenclerkS.maintenance': {
          templateUrl: '/templates/zenclerk_s/common/maintenance/maintenance.html'
        }
      }
    }).state('zenclerkS.project.maintenance', {
      url: '/maintenance',
      views: {
        'mainContent@zenclerkS.project': {
          template: '<zcs-maintenance></zcs-maintenance>'
        }
      }
    }).state('zenclerkS.project.tag_unset', {
      url: '/tag_unset',
      views: {
        'mainContent@zenclerkS.project': {
          template: '<zcs-tag-unset></zcs-tag-unset>'
        }
      }
    }).state('zenclerkS.agency', {
      url: '/agencies/:agencyName',
      abstract: true,
      views: {
        'layout@': {
          templateUrl: '/templates/zenclerk_s/layout/layout_main+sidebar-left.html'
        },
        'sidebarContent@zenclerkS.agency': {
          template: '<zcs-agency-sidebar></zcs-agency-sidebar>'
        }
      },
      resolve: {
        agency($stateParams, Agency) {
          return Agency.get(`name:${$stateParams.agencyName}`);
        }
      }
    }).state('zenclerkS.agency.home', {
      url: '',
      views: {
        'mainContent@zenclerkS.agency': {
          template: '<zcs-agency-home agency="$resolve.agency"></zcs-agency-home>'
        }
      },
      data: {
        category: 'agencyHome'
      }
    }).state('zenclerkS.agency.campaigns', {
      url: '/campaigns',
      views: {
        'mainContent@zenclerkS.agency': {
          templateUrl: '/templates/zenclerk_s/agencies/campaigns/agency_campaigns.html'
        }
      },
      data: {
        category: 'agencyCampaigns'
      }
    }).state('zenclerkS.agency.invoices', {
      abstract: true,
      url: '/invoices',
      data: {
        category: 'agencyInvoices'
      }
    }).state('zenclerkS.agency.invoices.list', {
      url: '',
      views: {
        'mainContent@zenclerkS.agency': {
          templateUrl: '/templates/zenclerk_s/agencies/invoices/list.html',
          controllerAs: 'vm',
          controller: 'ZcsAgencyInvoicesListController'
        }
      },
      resolve: {
        invoices(ZcsAgencyInvoice, agency) {
          return ZcsAgencyInvoice.all(agency.name);
        }
      },

      data: {
        category: 'agencyInvoices'
      }
    }).state('zenclerkS.agency.invoices.show', {
      url: '/:term',
      views: {
        'mainContent@zenclerkS.agency': {
          templateUrl: '/templates/zenclerk_s/agencies/invoices/show.html',
          controllerAs: 'vm',
          controller: 'ZcsAgencyInvoiceShowController'
        }
      },
      resolve: {
        invoice($stateParams, ZcsAgencyInvoice, agency) {
          return ZcsAgencyInvoice.find(agency.name, $stateParams.term);
        },
        projects($stateParams, AgencyProject) {
          return AgencyProject.all($stateParams.agencyName);
        }
      },
      data: {
        category: 'agencyInvoices'
      }
    }).state('zenclerkS.agency.sites', {
      url: '/sites',
      views: {
        'mainContent@zenclerkS.agency': {
          template: '<zcs-agency-site-list agency="$resolve.agency"></zcs-agency-site-list>'
        }
      },
      data: {
        category: 'agencySites'
      }
    }).state('zenclerkS.agency.sites.new', {
      url: '/sites/new?demo',
      views: {
        'mainContent@zenclerkS.agency': {
          templateUrl: '/templates/zenclerk_s/agencies/sites/new.html',
          controllerAs: 'vm',
          controller: 'ZcsAgencyCreateSiteController',
          resolve: {
            regions(Meta) {
              return Meta.getRegions();
            },
            salesEntities(Meta) {
              return Meta.getSalesEntities();
            },
          }
        }
      },
      data: {
        category: 'agencySites'
      }
    }).state('zenclerkS.agency.sitesInInstallation', {
      url: '/sites-in-installation',
      views: {
        'mainContent@zenclerkS.agency': {
          template: '<zcs-agency-sites-in-installation agency="$resolve.agency"></zcs-agency-sites-in-installation>'
        }
      },
      data: {
        category: 'agencySitesInInstallation'
      }
    }).state('zenclerkS.agency.sitesUserActivity', {
      url: '/sites-user-activity',
      views: {
        'mainContent@zenclerkS.agency': {
          template: '<zcs-agency-sites-user-activity agency="$resolve.agency"></zcs-agency-sites-user-activity>'
        }
      },
      data: {
        category: 'agencySitesUserActivity'
      }
    }).state('zenclerkS.agency.users', {
      url: '/users',
      views: {
        'mainContent@zenclerkS.agency': {
          templateUrl: '/templates/zenclerk_s/agencies/users/agency_users.html',
          controllerAs: 'vm',
          controller: 'ZcsAgencyUsersController'
        }
      },
      resolve: {
        users($stateParams, AgencyUser) {
          return AgencyUser.all($stateParams.agencyName);
        },
        currentUser(Devise) {
          return Devise.getCurrentUser();
        }
      },
      data: {
        category: 'agencyUsers'
      }
    }).state('zenclerkS.agency.settings', {
      url: '/settings',
      views: {
        'mainContent@zenclerkS.agency': {
          templateUrl: '/templates/zenclerk_s/agencies/settings/agency_settings.html',
          controllerAs: 'vm',
          controller: 'ZcsAgencySettingsController'
        }
      },
      data: {
        category: 'agencySettings'
      }
    });
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/routes.js